



































import { Vue, Component, Watch } from 'vue-property-decorator';
import { RouteNames } from './_routes';
import { alert } from '@/common/modal';
import { Subscription } from 'vue-rx-decorators';
import { Cache } from '../../common/cache';
import { Facilities, User, InmateSource } from '@lantern/lantern-sdk';
import { log } from 'util';

@Component({
    components: {},
})
export default class FacilitiesComponent extends Vue {
    RouteNames = RouteNames;
    userInfo: User.Info | null = null;

    loading = true;

    canvasRootAccount = Number(process.env.VUE_APP_CANVAS_ROOT);

    @Subscription(() => Cache.instance.isAdmin)
    isAdmin!: boolean | null;

    @Subscription(() => Cache.instance.user)
    user!: User.Info | null;

    @Subscription(() => Cache.instance.accounts)
    accounts!: User.CanvasAccounts | { mainAccounts: []; subAcccounts: [] };

    @Subscription(() => Cache.instance.facilities)
    facilities!: Facilities.Document | null;

    async created() {
        console.log(`facility created`);

        const response = await this.$lantern.endpoints.User.getAccounts();
        const accounts = response.data;
        console.log(accounts);

        this.$cache.accounts.next(accounts);
        this.loading = false;
        if (this.accounts.mainAccounts.length === 0) {
            await alert('Access denied!');
        } else {
            await this.getFacilities();
        }
    }

    manageAccounts() {
        this.$router.push(RouteNames.manage);
    }

    status() {
        this.$router.push(RouteNames.status);
    }

    async getFacilities() {

        try {
            const svisRequest = { inmateSource: InmateSource.svis };
            const jpayRequest = { inmateSource: InmateSource.jpay };

            const svisPro = this.$lantern.endpoints.Facilities.list(svisRequest);
            const jpayPro = this.$lantern.endpoints.Facilities.list(jpayRequest);

            const responseAll = await Promise.all([svisPro, jpayPro]);
            const facilities = responseAll.map(res => res.data.items).flat();

            this.$cache.facilities.next(facilities);

        } catch (err: any) {
            await alert(err.message);
        }
    }
}
